// profile/index.ts
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { ContentType, itemList } from '@/utils/settings.options';
import SettingStorage, { storageLabels } from '@/utils/settings.storage';

const contentType = () => {
  if (SettingStorage.getOptionValue(itemList.content) !== false) {
    return SettingStorage.getOptionValue(itemList.content);
  } else {
    return ContentType.Mix;
  }
};

const timeLimit = () => {
  if (SettingStorage.timeLimitIsSet()) {
    return Number(SettingStorage.getStorageValue(storageLabels.timeLimit));
  } else {
    return 90 * 60;
  }
};

const timeIsSet = () => {
  if (SettingStorage.timeLimitIsSet()) {
    return true;
  } else {
    return false;
  }
};

const getSoundSetting = () => {
  if (SettingStorage.findItemType(itemList.other) === null || SettingStorage.playSound()) {
    return true;
  } else {
    return false;
  }
};

const getAge = () => {
  return SettingStorage.getOptionValue(storageLabels.age);
};

const getLanguage = () => {
  return SettingStorage.getOptionValue(storageLabels.language).value;
};

export const playlist = () => {
  const playlistStorage = localStorage.getItem('playlist');
  return playlistStorage !== null ? playlistStorage : JSON.stringify([]);
};

export const updateStoreFromStorage = (store) => {
  store.commit('settings/setType', contentType());
  store.commit('settings/setTimeLimit', timeLimit());
  store.commit('settings/setTimeVariable', timeIsSet());
  store.commit('settings/setSound', getSoundSetting());
  store.commit('settings/setVideoPlaylist', playlist());
};

export const state = {
  content: contentType(),
  time: timeLimit(),
  age: getAge(),
  language: getLanguage(),
  timeIsSet: timeIsSet(),
  soundActive: getSoundSetting(),
  playlist: playlist(),
  videoIsPaused: false,
  videoList: [],
  isAgeSettingDisplayed: false,
  ageSettingPath: 'settings',
  showExpiration: false,
  displayLoader: false,
  displayVideoLoader: false,
  loadingCards: false,
  focusSettings: false,
  focusLiveLink: false,
  focusKidjoWorldLink: false,
  focusSearchLink: false,
  activeHeaderNav: false,
  hideMobileCard: false,
  activeLiveMode: false,
  activeBanner: false,
  activeHeaderBanner: false,
  activSettingsCloseBtn: false,
  isNotificationVisible: {
    status: false,
    title: null,
    message: null,
    closeButton: true
  }
};

const namespaced = true;

export const settings = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
